import Axios from 'axios';
import Api from './Api';
import Config from './Config';
import {timeString} from './Utils'
import sha1 from 'crypto-js/sha1'
import {showLoading, hideLoading} from "./IntegratedProcessing";
import dayjs from 'dayjs'

const noLoadingList = [Api.getWechatSignature]

// 添加请求拦截器
Axios.interceptors.request.use(function (config) {
	// 在发送请求之前做些什么
	if (!noLoadingList.includes(config.url)) showLoading();
	return config;
}, function (error) {
	// 对请求错误做些什么
	hideLoading()
	return Promise.reject(error);
});

// 添加响应拦截器
Axios.interceptors.response.use(function (response) {
	// 对响应数据做点什么
	let {status} = response
	let responseData = response.data
	if (status === 200) {
	}
	if (!noLoadingList.includes(response.config.url)) hideLoading();
	return responseData;
}, function (error) {
	// 对响应错误做点什么
	hideLoading()
	return Promise.reject(error);
});

/**
 * @desc 获取加密签名
 * @param appSecret
 * @param appKey
 * @param data
 * @param timestamp
 * @returns {string}
 * @private
 */
function _getSign({appSecret, appKey, data, timestamp}) {
	return sha1(appSecret + 'appKey' + appKey + 'bizContent' + JSON.stringify(data) + 'timestamp' + timestamp + appSecret).toString().toUpperCase()
}

/**
 * 获取用户信息
 * @return {{userId: *, token: *}}
 * @private
 */
function _getUserInfo() {
	let {loginInfo} = Config
	let userId = Config.userId
	let token = null
	let phoneNum = null
	if (loginInfo) {
		userId = loginInfo.userId
		token = loginInfo.token
		phoneNum = loginInfo.phoneNum
	}
	return {userId, token, phoneNum}
}

// 获取短信验证码
function getMsgCode(options) {
	let params = {
		phonenum: options.phoneNumber,
		modelid: Config.messageInfo.modelId,
		templateid: Config.messageInfo.templateId,
		key: options.key, // 图形验证码key
		validCode: options.validCode // 图形验证码value
	}
	return Axios.get(Api.msgCode, {params: params})
}

function userLogin(options) { // 用户登录
	let data = {
		clientVersionId: Config.clientId,
		registerFrom: Config.messageInfo.registerFrom, // 注册来源
		channelId: Config.channelId,
		extendInfo: {
			extendType: options.inviteCode ? 'YQM' : 'SMS',
			modelid: Config.messageInfo.modelId, // 组件Id
			templateid: Config.messageInfo.templateId, // 短信配置Id
			smsValiCode: options.smsValiCode // 短信验证码微信
		},
		mobile: options.mobile, // 手机号
		password: '', // 如果不填,根据不同的注册类型,有不同的密码(微信:手机号后六位)
		loginType: options.inviteCode ? '8' : '1' // 登录类型;1,手机号+验证码; 8、邀请码注册
	}
	if (options.inviteCode) {
		data.extendInfo.inviteCode = options.inviteCode
	}
	return Axios.post(Api.login, data)
}

/**
 * @desc 下单接口
 * @param skuId 商品ID
 * @param channelSkuId 商品ID
 * @param num 购买数量
 * @param ext
 * @param payMethodCode 支付方式ID
 * @param invoice 发票信息
 * @returns {*|AxiosPromise<any>}
 */
function submit(options) {
	let {userId, token} = _getUserInfo()
	let {
		skuId,
		channelSkuId,
		channelAccount = '',
		num,
		ext,
		payMethodCode,
		payMethodSubCode,
		payReturnUrl,
		unpayReturnUrl,
		coupons = [],
		invoice,
		otherProperties
	} = options
	let data = {
		client: {
			clientVersionId: Config.clientId,
			clientVersionNo: Config.clientVersionNo,
			clientType: '',
			deviceId: '',
			deviceCode: '',
			deviceBrand: '',
			deviceType: '',
			position: '',
			positionName: '',
			srcType: '',
			srcObjectId: ''
		},
		order: {
			orderItems: [{
				skuId: skuId,
				channelSkuId: channelSkuId || '',
				num: num,
				ext: ext
			}],
			appId: Config.appId, // SDK支付需要传
			payMethodCode,
			payMethodSubCode, // 子支付方式code
			payReturnUrl,
			unpayReturnUrl,
			loginUserId: userId,
			loginStaffId: '',
			channelOrderNo: '',
			channelId: Config.channelId,
			channelAccount,
			channelAccountType: Config.channelId
		},
		// 优惠券信息
		coupons,
	}
	if (otherProperties) {
		data.otherProperties = JSON.stringify(otherProperties)
	}
	// 发票信息
	invoice && (data.invoice = invoice)
	let sign = _getSign({
		appSecret: Config.appSecret,
		appKey: Config.appKey,
		data: data,
		timestamp: timeString()
	})
	let url = ''
	url = Api.placeorder + '?authToken=' + (token || '') + '&sign=' + sign + '&appKey=' + Config.appKey + '&timestamp=' + timeString()
	return Axios.post(url, data)
}

// 1.5查询用户的领奖记录
function searchRewardRecord(options) {
	let {userId, token} = _getUserInfo()
	let params = {
		authType: Config.authType,
		clientId: Config.clientId,
		ext: JSON.stringify({
			myAuthToken: token
		}),
		schemeNo: Config.schemeNo,
		state: options.state || '',
		pageNo: '1',
		pageSize: options.pageSize || '',
		userId: userId
	}
	return Axios.post(Api.searchRewardRecord, params)
}

// 1.7.1用户开奖接口
function openReward(options) {
	let {userId, token} = _getUserInfo()
	let data = {
		authType: Config.authType,
		ext: JSON.stringify({
			myAuthToken: token,
			openId: Config.bocOpenId,
			myOpenId: Config.fzsOpenId
		}),
		sendNo: options.sendNo,
		userId: userId,
		voucherParams: { // 领红包需要用蜂助手的openid
			voucherKey: 'openId',
			voucherValue: Config.fzsOpenId
		}
	}
	return Axios.post(Api.openReward, data)
}

// 中行第三方登录
function bocLogin(options) {
	let data = {
		// authType: Config.authType,
		channelId: Config.channelId,
		clientVersionId: Config.clientId,
		registerFrom: Config.channelId,
		thirdToken: options.thirdToken,
		uid: ''
	}
	return Axios.post(Api.bocLogin, data)
}

// 2.0.1 白名单接口 获取商品列表
function getAllProductList() {
	let {userId, token} = _getUserInfo()
	let data = {
		authType: Config.authType,
		clientId: Config.clientId,
		ext: JSON.stringify({
			myAuthToken: token
		}),
		schemeNo: Config.schemeNo,
		userId: userId
	}
	return Axios.post(Api.getAllProductList, data)
}

/**
 * 1.17.查询任务的奖励资格列表
 * clientId 客户端ID
 * rconfigNo 奖励编号
 * taskNo 任务编号
 * */
function getTaskRewardInfo() {
	return Axios.post(Api.getTaskRewardInfo, {
		clientId: Config.clientId,
		taskNo: Config.taskNo
	})
}

/**
 * 1.6查询中奖轮播数据
 * @return {*}
 */
function getRankList() {
	let data = {
		clientId: Config.clientId,
		endTime: dayjs().format('YYYY-MM-DD HH:mm:ss'), // 领奖结束时间
		startTime: dayjs().subtract(5, 'day').format('YYYY-MM-DD HH:mm:ss'), // 领奖开始时间
		pageNo: 1,
		pageSize: 20,
		schemeNo: Config.schemeNo,
		rdefType: 'PRODUCT',
		state: '' // 1 发货成功
	}
	return Axios.post(Api.getRankList, data)
}

/**
 * 2.4.6转换中行用户信息加密串，下单用
 * @param options
 * @return {*}
 */
function changeBocString (options) {
	let data = {
		authType: Config.authType,
		checkIbknum: '1',
		cipherText: options.cipherText
	}
	console.log(data);
	return Axios.post(Api.changeBocString, data)
}

// 1.3收集用户行为
function collectionUserAction(options) {
	let {userId, token} = _getUserInfo()
	let data = {
		userId: userId,
		authType: Config.authType, // 授权类型
		clientId: Config.clientId,
		ext: JSON.stringify({
			myAuthToken: token
		}),
		actionParams: options.actionParams
	}
	if (options.voucherParams) {
		data.voucherParams = options.voucherParams
	}
	return Axios.post(Api.collectionUserAction, data)
}

// 1.23.1 查询分享排行榜接口
function getShareList(options) {
	let {userId} = _getUserInfo()
	let data = {
		authType: Config.authType,
		actionNo: Config.rankTaskNo,
		pageNo: options.pageNo || '1',
		pageSize: '200',
		userId: userId
	}
	return Axios.post(Api.getShareList, data)
}

// 获取微信分享服务
function weChatServer(params) {
	return Axios.get(Api.getWeChatSignature, params)
}

// 查询开门红活动用户的排名详情
function getUserRankInfo () {
	let {userId, token} = _getUserInfo()
	let data = {
		actionNo: Config.rankTaskNo,
		authType: Config.authType,
		schemeNo: Config.schemeNo,
		userId: userId,
		ext: JSON.stringify({
			myAuthToken: token
		})
	}
	return Axios.post(Api.getUserRankInfo, data)
}

/**
 * 登记分享次数
 */
function checkShareTime() {
	let params = {
		actionNo: Config.rankTaskNo,
		authType: 'FZS',
		userId: Config.shareUserId
	}
	return Axios.get(Api.checkShareTime, {params: params})
}

/**
 * 登记绑定中行openId
 * @return {*}
 */
function loginBocUserInFzs () {
	let {userId, token} = _getUserInfo()
	let data = {
		authType: Config.authType,
		clientId: Config.clientId,
		userId: userId,
		openId: Config.bocOpenId,
		ext: JSON.stringify({
			myAuthToken: token
		})
	}
	return Axios.post(Api.loginBocUserInFzs, data)
}

/**
 * 事件登记接口
 * @return {*}
 */
function checkEventCollect() {
	let {userId, phoneNum} = _getUserInfo()
	let data = {
		businessCode: 'BOC_NEW_SPRING',
		eventCode: 'BOC_FORWARD',
		userId: userId,
		mobile: phoneNum
	}
	return Axios.get(Api.checkEventCollect, {params: data})
}

export {
	_getUserInfo,
	getMsgCode, // 获取短信验证码
	userLogin, // 用户登录
	submit, // 提交订单
	searchRewardRecord, // 1.5查询用户的领奖记录
	openReward, // 1.7.1用户开奖接口
	bocLogin, // 中行第三方登录
	getAllProductList, // 2.0.1 白名单接口 获取商品列表
	getTaskRewardInfo, // 查询任务的奖励资格列表
	getRankList, // 1.6查询中奖轮播数据
	changeBocString, // 2.4.6转换中行用户信息加密串
	collectionUserAction, // 1.3收集用户行为
	getShareList, // 1.23.1 查询分享排行榜接口
	weChatServer, // 获取微信分享服务
	getUserRankInfo, // 查询开门红活动用户的排名详情
	checkShareTime, // 登记分享次数
	loginBocUserInFzs, // 登记绑定中行openId
	checkEventCollect, // 事件登记接口
}
